import store from "../store";
import { PORTAL_HOME_SETTINGS } from "@/config";
import { extractCountryCode } from "@/utils/tenantUtils";

export function resolveTenantCountryCodeForPortal() {
  const fromStore = store.getters.tenantId;
  if (fromStore) {
    return String(fromStore).trim().toUpperCase();
  }
  if (typeof window !== "undefined") {
    const fromUrlOrLocal = extractCountryCode(window.location.href);
    if (fromUrlOrLocal) {
      return String(fromUrlOrLocal).trim().toUpperCase();
    }
  }
  return null;
}

export function isPortalTenantEligibleForHome() {
  const tenantCode = resolveTenantCountryCodeForPortal();
  return (
    PORTAL_HOME_SETTINGS.isEnabled() &&
    tenantCode &&
    PORTAL_HOME_SETTINGS.isTenantEligible(tenantCode)
  );
}

export function portalHomeBeforeEnter(to, from, next) {
  if (!isPortalTenantEligibleForHome()) {
    return next({ name: "dashboard" });
  }
  next();
}
